import { useEffect, useState } from 'react';

export const WIDE_ENOUGH_FOR_INLINE_NAV = '(min-width: 768px)';

const read = (query: string, fallback: boolean) =>
  typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback;

export function useMediaQuery(query: string, fallback = true): boolean {
  const [matches, setMatches] = useState(() => read(query, fallback));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [query]);

  return matches;
}
